/** Include unfinished code spans/fences so streaming cannot erase their contents. */
export function markdownCodeRanges(
  text: string,
): { start: number; end: number }[] {
  const ranges: { start: number; end: number }[] = [];
  let open: { start: number; delimiter: string; fenced: boolean } | undefined;

  for (const match of text.matchAll(
    /^ {0,3}(`{3,}|~{3,})([^\n]*)(?:\n|$)|(`+)/gm,
  )) {
    const delimiter = match[1] ?? match[3]!;
    const fenced = match[1] !== undefined;
    if (open) {
      const closes = open.fenced
        ? fenced &&
          delimiter[0] === open.delimiter[0] &&
          delimiter.length >= open.delimiter.length &&
          !match[2]?.trim()
        : delimiter === open.delimiter;
      if (closes) {
        ranges.push({
          start: open.start,
          end: match.index + (open.fenced ? match[0].length : delimiter.length),
        });
        open = undefined;
      }
      continue;
    }

    let backslashes = 0;
    for (let i = match.index - 1; i >= 0 && text[i] === '\\'; i -= 1)
      backslashes += 1;
    if (backslashes % 2 === 1) continue;
    open = { start: match.index, delimiter, fenced };
  }

  if (open) ranges.push({ start: open.start, end: text.length });

  return ranges;
}
